export default "__VITE_ASSET__0hEWi3y___"